












































import {
  Component,
  Prop,
  Vue
} from "vue-property-decorator";
import {
  CartItemResponse,
  deleteCartItem,
  updateCartItem
} from '@/classes/TayehApi/Customer'
import ImageView from "../ImageView.vue";
@Component({
  components: {
    ImageView
  }
})
export default class CartItem extends Vue {
  @Prop() item!: CartItemResponse;
  @Prop({
    default: false
  }) fullscreen!: boolean;
  @Prop({default: false}) disabledItem!: boolean;
  loading = false;
  async deleteCartItem() {
    await deleteCartItem(this.item.cart_item_id)
    this.$store.dispatch('updateCart');
  }
  async updateCartItem (count: number) {
    // if (this.item.count===count) return;
    this.loading = true;
    try {
      await updateCartItem({
        cart_item_id: this.item.cart_item_id,
        count
      });
      // this.$store.commit('setCart', res.data);
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  }
  handleNavigation() {
    this.$emit('close');
  }
}
